// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__v9ELF","selected":"Chip_selected__2C3m_"};